/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolunteerResponse
 */
export interface VolunteerResponse {
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    volunteerId: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof VolunteerResponse
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the VolunteerResponse interface.
 */
export function instanceOfVolunteerResponse(value: object): value is VolunteerResponse {
    if (!('volunteerId' in value) || value['volunteerId'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('salutation' in value) || value['salutation'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function VolunteerResponseFromJSON(json: any): VolunteerResponse {
    return VolunteerResponseFromJSONTyped(json, false);
}

export function VolunteerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolunteerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'volunteerId': json['volunteerId'],
        'username': json['username'],
        'salutation': json['salutation'],
        'title': json['title'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'email': json['email'],
        'phone': json['phone'],
        'remarks': json['remarks'],
    };
}

export function VolunteerResponseToJSON(json: any): VolunteerResponse {
    return VolunteerResponseToJSONTyped(json, false);
}

export function VolunteerResponseToJSONTyped(value?: VolunteerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'volunteerId': value['volunteerId'],
        'username': value['username'],
        'salutation': value['salutation'],
        'title': value['title'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'email': value['email'],
        'phone': value['phone'],
        'remarks': value['remarks'],
    };
}

